const FallbackOldData = {
  TEAM_BLOCK_VIDEO_URL: 'https://www.youtube.com/embed/L1w0-_oNXJM?si=7r8Sob6tZhctMHLg',
  CUSTOMERS_COUNT: 'יותר מ1000',
};

export const TeamBlockData = {
  VIDEO_URL: window.TEAM_BLOCK_VIDEO_URL || FallbackOldData.TEAM_BLOCK_VIDEO_URL,
  CUSTOMERS_COUNT: window.CUSTOMERS_COUNT || FallbackOldData.CUSTOMERS_COUNT,
};
